import config from "@/config"

//系统路由
const routes = [
	{
		name: "layout",
		path: "/",
		component: () => import(/* webpackChunkName: "layout" */ '@/layout'),
		redirect: config.DASHBOARD_URL || '/dashboard',
		children: []
	},
	{
		path: "/login",
		component: () => import(/* webpackChunkName: "login" */ '@/views/login'),
		meta: {
			title: "登录"
		}
	},
	// 后台账号由管理员在系统内维护，不开放页面注册（后端本无注册接口，路由一并屏蔽）
	// {
	// 	path: "/user_register",
	// 	component: () => import(/* webpackChunkName: "userRegister" */ '@/views/login/userRegister'),
	// 	meta: {
	// 		title: "注册"
	// 	}
	// },
	{
		path: "/reset_password",
		component: () => import(/* webpackChunkName: "resetPassword" */ '@/views/login/resetPassword'),
		meta: {
			title: "重置密码"
		}
	},
	{
		//微信开放平台授权结果独立页（后端授权回调跳转，hash query传参，免登录展示）
		path: "/appset/authResult",
		component: () => import(/* webpackChunkName: "appset-authResult" */ '@/views/appset/authResult'),
		meta: {
			title: "授权结果"
		}
	}
]

export default routes;
